// Shared privacy guard for analytics trackers (Meta Pixel, GA4).
//
// Both trackers attach the current page URL to the events they send. Several
// RegattaReplay routes carry a bearer/capability token in the URL — accepting
// an invite, confirming identity, unsubscribing, claiming a track, or the
// passwordless login magic-link. Transmitting those to a third party would leak
// a credential correlatable to a profile. This predicate identifies such URLs so
// callers can suppress or redact them.
//
// `/auth/verify?token=` is the login magic-link (a full account credential);
// `?token=` is its query param, `?previewToken=` is the signed race-preview token.
const TOKEN_PATH_PREFIXES = ['/invite', '/confirm', '/unsubscribe', '/claim', '/auth/verify'];
const TOKEN_QUERY_PARAMS = ['token', 'previewToken'];

/** True when the path/query carries a secret token that must not reach a tracker. */
export function isTokenBearingUrl(pathname: string, search: string): boolean {
  // react-router matches paths case-insensitively, so lowercase before compare
  // to avoid a `/INVITE/abc` bypass that still renders the token page.
  const path = pathname.toLowerCase();
  const hasTokenPath = TOKEN_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
  if (hasTokenPath) return true;

  const params = new URLSearchParams(search);
  return TOKEN_QUERY_PARAMS.some((key) => params.has(key));
}
